import React from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import Select from 'react-select';
import { menuPortalProps, menuPortalStyles } from './selectMenuPortal';

var TabImoveis = function (_ref) {
  var parametros = _ref.parametros;
  var onChange = _ref.onChange;
  var gesLookup = _ref.gesLookup;

  var p = parametros || {};

  var handleChange = function (campo, valor) {
    onChange(Object.assign({}, p, { [campo]: valor }));
  };

  var gesOptions = (gesLookup || []).map(function (g) {
    return { value: g.codigo, label: g.codigo + ' - ' + (g.apelido || '') };
  });

  var geGestorOpt = gesOptions.find(function (g) { return g.value === p.ge_gestor; }) || null;
  var geComissaoOpt = gesOptions.find(function (g) { return g.value === p.ge_comissao_imob; }) || null;

  return (
    <div>
      <Row>
        <Col md={3}>
          <Form.Group>
            <Form.Label>Administração (%)</Form.Label>
            <Form.Control
              type="number"
              step="0.01"
              value={p.taxa_adm || ''}
              onChange={function (e) { handleChange('taxa_adm', e.target.value); }}
            />
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group>
            <Form.Label>Impostos (%)</Form.Label>
            <Form.Control
              type="number"
              step="0.01"
              value={p.impostos || ''}
              onChange={function (e) { handleChange('impostos', e.target.value); }}
            />
          </Form.Group>
        </Col>
        <Col md={2}>
          <Form.Group>
            <Form.Label>Venda Imóvel</Form.Label>
            <Form.Control
              as="select"
              value={p.venda_imovel || 'N'}
              onChange={function (e) { handleChange('venda_imovel', e.target.value); }}
            >
              <option value="S">Sim</option>
              <option value="N">Não</option>
            </Form.Control>
          </Form.Group>
        </Col>
        <Col md={2}>
          <Form.Group>
            <Form.Label>Part. Societária (%)</Form.Label>
            <Form.Control
              type="number"
              step="0.01"
              value={p.sociedade || ''}
              onChange={function (e) { handleChange('sociedade', e.target.value); }}
            />
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col md={4}>
          <Form.Group>
            <Form.Label>GE. Gestor Transferência</Form.Label>
            <Select
              value={geGestorOpt}
              options={gesOptions}
              onChange={function (opt) { handleChange('ge_gestor', opt ? opt.value : null); }}
              placeholder="Selecione o GE gestor..."
              isClearable
              {...menuPortalProps}
              styles={menuPortalStyles}
            />
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group>
            <Form.Label>Conta Central. Transferência</Form.Label>
            <Form.Control
              type="number"
              value={p.conta_transf || ''}
              onChange={function (e) { handleChange('conta_transf', e.target.value); }}
            />
            <Form.Text className="text-muted">
              GE Gestor e Conta Transferência: ambos preenchidos ou ambos vazios.
            </Form.Text>
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col md={2} className="d-flex align-items-center">
          <Form.Check
            type="checkbox"
            label="Justificativa Pré-Venda não Efetivada"
            checked={p.just_pre_venda === 'S'}
            onChange={function (e) { handleChange('just_pre_venda', e.target.checked ? 'S' : 'N'); }}
          />
        </Col>
        <Col md={2} className="d-flex align-items-center">
          <Form.Check
            type="checkbox"
            label="Correção Automática"
            checked={p.corrige_automatico === 'S'}
            onChange={function (e) { handleChange('corrige_automatico', e.target.checked ? 'S' : 'N'); }}
          />
        </Col>
        <Col md={2} className="d-flex align-items-center">
          <Form.Check
            type="checkbox"
            label="Boleto Automático"
            checked={p.boleto_automatico === 'S'}
            onChange={function (e) { handleChange('boleto_automatico', e.target.checked ? 'S' : 'N'); }}
          />
        </Col>
        <Col md={2} className="d-flex align-items-center">
          <Form.Check
            type="checkbox"
            label="Sinal Urbanizadora"
            checked={p.sinal_urbanizadora === 'S'}
            onChange={function (e) { handleChange('sinal_urbanizadora', e.target.checked ? 'S' : 'N'); }}
          />
        </Col>
      </Row>

      <Row className="mt-2">
        <Col md={3}>
          <Form.Group>
            <Form.Label>Recebimento de Aluguel — Conta</Form.Label>
            <Form.Control
              type="number"
              value={p.aluguel_rec || ''}
              onChange={function (e) { handleChange('aluguel_rec', e.target.value); }}
            />
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group>
            <Form.Label>C.C. Aluguel</Form.Label>
            <Form.Control
              type="number"
              value={p.cc_aluguel_rec || ''}
              onChange={function (e) { handleChange('cc_aluguel_rec', e.target.value); }}
            />
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group>
            <Form.Label>Comissão dentro do contrato — GE</Form.Label>
            <Select
              value={geComissaoOpt}
              options={gesOptions}
              onChange={function (opt) { handleChange('ge_comissao_imob', opt ? opt.value : null); }}
              placeholder="Selecione o GE..."
              isClearable
              {...menuPortalProps}
              styles={menuPortalStyles}
            />
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col md={3}>
          <Form.Group>
            <Form.Label>Comissão — Conta Imobiliária</Form.Label>
            <Form.Control
              type="number"
              value={p.conta_int_imobiliaria || ''}
              onChange={function (e) { handleChange('conta_int_imobiliaria', e.target.value); }}
            />
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group>
            <Form.Label>Comissão — Despesa Comissão</Form.Label>
            <Form.Control
              type="number"
              value={p.conta_desp_comissao || ''}
              onChange={function (e) { handleChange('conta_desp_comissao', e.target.value); }}
            />
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group>
            <Form.Label>C.C. Desp. Comissão</Form.Label>
            <Form.Control
              type="number"
              value={p.cc_conta_desp_comissao || ''}
              onChange={function (e) { handleChange('cc_conta_desp_comissao', e.target.value); }}
            />
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col md={3}>
          <Form.Group>
            <Form.Label>Receita Cancel. Int. Vendas — Conta</Form.Label>
            <Form.Control
              type="number"
              value={p.cre_can_int_vendas || ''}
              onChange={function (e) { handleChange('cre_can_int_vendas', e.target.value); }}
            />
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group>
            <Form.Label>C.C. Receita Cancel. Int. Vendas</Form.Label>
            <Form.Control
              type="number"
              value={p.cc_cre_can_int_vendas || ''}
              onChange={function (e) { handleChange('cc_cre_can_int_vendas', e.target.value); }}
            />
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group>
            <Form.Label>Despesa de IPTU — Conta</Form.Label>
            <Form.Control
              type="number"
              value={p.conta_desp_iptu || ''}
              onChange={function (e) { handleChange('conta_desp_iptu', e.target.value); }}
            />
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group>
            <Form.Label>C.C. IPTU</Form.Label>
            <Form.Control
              type="number"
              value={p.cc_conta_desp_iptu || ''}
              onChange={function (e) { handleChange('cc_conta_desp_iptu', e.target.value); }}
            />
          </Form.Group>
        </Col>
      </Row>
    </div>
  );
};

export default TabImoveis;
